import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { UtilsService } from './utils.service';
@Injectable({
  providedIn: 'root',
})
export class ControlPanelService {
  constructor(private apiService: ApiService,private UtilsService:UtilsService) { }

  getAllFields(payload: any={}): Observable<any[]> {
   
    const requestParams = this.UtilsService.convertObjectToQueryString(payload)
    return this.apiService.get(`/masters/fields?${requestParams}`).pipe(
      map((res: any) => res || [])
    );
  }


  createOrUpdateSettings(data: any): Observable<any> {
    return this.apiService.post('/masters', data).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getSettings(payload:any={}): Observable<any[]> {
    const requestParams = this.UtilsService.convertObjectToQueryString(payload)
    return this.apiService.get(`/masters/settings?${requestParams}`).pipe(
      map((res: any) => res || {})
    );
  }




  getSubCategories(): Observable<any[]> {
    return this.apiService.get(`/masters/sub-categories`).pipe(
      map((res: any) => {
        return res || {};
      })
    );
  }

  getValidations(): Observable<any[]> {
    return this.apiService.get(`/masters/validations`).pipe(
      map((res: any) => res || {})
    );
  }


  uploadFollowUpEcg(patientId: string, ecgFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('patientId', patientId);
    formData.append('ecgFile', ecgFile);

    return this.apiService.post(`/masters/upload`, formData).pipe(
      map((res: any) => res)
    );
  }

  uploadEcg( ecgFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('ecgFile', ecgFile);
    return this.apiService.post(`/ecg/upload`, formData).pipe(
      map((res: any) => res)
    );
  }

  getAllEcgFiles(patientId: string): Observable<any[]> {
    return this.apiService.post(`/masters/getAllECGFiles`, { patientId }).pipe(
      map((res: any) => res?.Response || [])
    )
  }

}
